import React from 'react';
import * as utils from './utils';
import AreaChart from '../AreaChart/AreaChart';


const Chart = (props) => {
  const { height, alertCutoff, scale, domainMin, domainMax, type, panel } = props.chartProps;
  const { times, unit } = props; 
    let decimalValue;
    let refLine;
    let transfer;
    let color;
    switch(type) {
      case "response": {
        decimalValue = utils.setDecimal(times);
        refLine = true;
        color = "#8884d8";
        break;
      }
      case "transfer": {
        decimalValue = false;
        refLine = false;
        transfer = true;
        color = "#82ca9d";
        break;
      }
    }

    return (
    <AreaChart 
      height={height} 
      times={times} 
      color={color} 
      unit={unit} 
      decimal={decimalValue} 
      refLine={refLine} 
      transfer={transfer} 
      alertCutoff={alertCutoff} 
      scale={scale} 
      domainMin={domainMin}
      domainMax={domainMax}
      panel={panel} 
      ticks={props.ticks}
    />);
  }

export default Chart;


// WEBPACK FOOTER //
// ./src/components/ChartCard/Chart.js